import { Uuid } from '@hidat/huijs-common';

export enum SteeringMode {
  StartingPath = 1, // Nothing scheduled, choose random mixes
  UpNext, // Currently playing, show what's up next
  ChangeDirection,
  ChooseNextMix, // Currently playing, but actively hunting for something different
}

export const SteeringReason = {
  ScheduledShow: 'ScheduledShow', // Next show that has been scheduled for a continous mix
  DetourShow: 'DetourShow',
  NextShowInSchedule: 'NextShowInSchedule',
  NextShowForProgram: 'NextShowForProgram',
  RelatedShow: 'RelatedShow',
  RandomShow: 'RandomShow',
  // Continuous Mixes
  RelatedMix: 'RelatedMix',
  RandomMix: 'RandomMix',
  ThemedMix: 'ThemedMix',
};
export type SteeringReasons =
  (typeof SteeringReason)[keyof typeof SteeringReason];

export interface SteeringPathInterface {
  steeringReason: SteeringReasons;
  klass: string | undefined;
  uid: Uuid | undefined;
  name: string | undefined;
  tagLine: string | undefined;
  description: string | undefined;
  hostName: string | undefined;
  programId: number | undefined;
  hostId: number | undefined;
  linkUrl: string | undefined;
  canPlay: boolean;
  canQueue: boolean;
}

export interface SteeringPathsInterface {
  straight?: SteeringPathInterface;
  left?: SteeringPathInterface;
  right?: SteeringPathInterface;

  scheduled?: SteeringPathInterface[];
  detours?: SteeringPathInterface[];
  related?: SteeringPathInterface[];
  random?: SteeringPathInterface[];
}
